import sparePartsApi, { ApiResponse } from "../../../api/spareParts.api";

import {
  MaintenanceAssignment,
  MaintenanceAssignmentFilters,
  MaintenanceAssignmentPagination,
  MaintenanceRole,
} from "./types";

class MaintenanceAssignmentsService {
  async getAssignments(filters: MaintenanceAssignmentFilters): Promise<{
    items: MaintenanceAssignment[];
    pagination: MaintenanceAssignmentPagination;
  }> {
    const response = await sparePartsApi.get<ApiResponse<MaintenanceAssignment[]>>(
      "/administration/maintenance-assignments",
      {
        params: {
          ...filters,
          maintenanceRole: filters.maintenanceRole || undefined,
          status: filters.status || undefined,
        },
      }
    );

    return {
      items: response.data.data || [],
      pagination: response.data.meta as MaintenanceAssignmentPagination,
    };
  }

  async assignRole(payload: {
    employeeId: string;
    maintenanceRole: MaintenanceRole | null;
    cityId?: string | null;
    assignedBy?: string;
  }): Promise<MaintenanceAssignment> {
    const response = await sparePartsApi.post<ApiResponse<MaintenanceAssignment>>(
      "/administration/maintenance-assignments",
      payload
    );

    return response.data.data;
  }

  async changeRole(
    employeeId: string,
    payload: {
      maintenanceRole: MaintenanceRole | null;
      cityId?: string | null;
      assignedBy?: string;
    }
  ): Promise<MaintenanceAssignment> {
    const response = await sparePartsApi.patch<ApiResponse<MaintenanceAssignment>>(
      `/administration/maintenance-assignments/${employeeId}`,
      payload
    );

    return response.data.data;
  }

  async removeRole(employeeId: string, assignedBy?: string): Promise<void> {
    await sparePartsApi.delete(
      `/administration/maintenance-assignments/${employeeId}`,
      {
        data: { assignedBy },
      }
    );
  }
}

export default new MaintenanceAssignmentsService();
